/**
 * i18n de Costos y stock (v3) — área INSUMOS (lista, ficha del insumo, preparados) y STOCK: claves cs.insumos.* y cs.stock.*.
 * Paridad exacta es/en/pt (claves y placeholders {x}): la controla src/v2/i18n/parity.test.js.
 * Los prefijos por área los controla costsV3.test.js (dos áreas no pueden pisarse).
 *
 * Voz: rioplatense con voseo, frases cortas, sin jerga. "Insumo" en listas y fichas,
 * "ingrediente" dentro de la receta; Compra, Contar, Pérdida, Corregir a mano.
 * Los estados con nombre fijo (Reponer, Sin stock, Falta precio…) y las unidades son del shell
 * (cs.shell.*): acá no se repiten.
 * Los números llegan ya formateados ({plata}, {qty}, {pct}): t() no formatea.
 */
const insumos = {
  es: {
    // ── Lista
    "cs.insumos.eyebrow": "Lo que comprás",
    "cs.insumos.sub": "El precio sirve para todos los platos que lo usan.",
    "cs.insumos.subStock": "El stock baja solo con cada venta.",
    "cs.insumos.head.precios": "Revisar precios",
    "cs.insumos.head.contar": "Contar",
    "cs.insumos.head.compra": "Cargar compra",
    "cs.insumos.seg.aria": "Ver insumos o preparados",
    "cs.insumos.seg.preparados": "Preparados",
    "cs.insumos.search.ph": "Buscar o agregar insumo…",
    "cs.insumos.search.prepPh": "Buscar preparado…",
    "cs.insumos.chips.aria": "Filtrar insumos",
    "cs.insumos.chips.todos": "Todos",
    "cs.insumos.chips.controlados": "Controlados",
    "cs.insumos.chips.reponer": "Para reponer",
    "cs.insumos.chips.sincontar": "Sin contar",
    "cs.insumos.chips.sinprecio": "Sin precio",
    "cs.insumos.kpi.value": "En mercadería",
    "cs.insumos.kpi.reponer": "Para reponer",
    "cs.insumos.kpi.out.one": "{n} sin stock",
    "cs.insumos.kpi.out.other": "{n} sin stock",
    "cs.insumos.kpi.sincontar": "Sin contar",
    "cs.insumos.kpi.last": "Último conteo",
    "cs.insumos.kpi.never": "Nunca",
    "cs.insumos.kpi.sinprecio": "Sin precio",
    "cs.insumos.kpi.mValue": "en mercadería",
    "cs.insumos.kpi.mReponer": "{n} para reponer",
    "cs.insumos.kpi.mSinContar": "{n} sin contar",
    "cs.insumos.kpi.mLast": "contaste {when}",
    "cs.insumos.kpi.mNever": "nunca contaste",
    "cs.insumos.noPrice.one": "1 insumo sin precio:",
    "cs.insumos.noPrice.other": "{n} insumos sin precio:",
    "cs.insumos.noPrice.body": "los platos que los usan quedan incompletos.",
    "cs.insumos.noPrice.see": "Ver cuáles",
    "cs.insumos.resume.t": "Te falta el paso 2:",
    "cs.insumos.resume.b": "contar lo que tenés. Sin ese número no sabemos cuánto hay y el mozo no ve nada.",
    "cs.insumos.resume.go": "Seguir",
    "cs.insumos.bulk.compra.one": "Cargar compra de este",
    "cs.insumos.bulk.compra.other": "Cargar compra de estos {n}",
    "cs.insumos.bulk.contar": "Contar",
    "cs.insumos.add.q": "Agregar \"{name}\"",
    "cs.insumos.add.qSub": "como insumo nuevo",
    "cs.insumos.empty.t": "Todavía no cargaste insumos",
    "cs.insumos.empty.b": "Son lo que comprás: la harina, la muzza, el aceite. Se suman solos cuando armás la receta de un plato, o agregalos acá.",
    "cs.insumos.empty.add": "Agregar un insumo",
    "cs.insumos.none.q": "No encontramos \"{q}\".",
    "cs.insumos.none.f": "No hay insumos con este filtro.",
    "cs.insumos.none.all": "Ver todos",
    "cs.insumos.col.insumo": "Insumo",
    "cs.insumos.col.precio": "Precio",
    "cs.insumos.col.uso": "Uso",
    "cs.insumos.col.hay": "Hay ahora",
    "cs.insumos.col.min": "Avisame con",
    "cs.insumos.col.estado": "Estado",
    "cs.insumos.col.precioDe": "Precio de",
    "cs.insumos.priceAge": "precio de {when}",
    "cs.insumos.uso.one": "1 plato",
    "cs.insumos.uso.other": "{n} platos",
    "cs.insumos.uso.prepOne": "en 1 preparado",
    "cs.insumos.uso.prepOther": "en {n} preparados",
    "cs.insumos.uso.none": "ninguno",
    "cs.insumos.act.comprar": "Comprar",
    "cs.insumos.act.contar": "Contar",
    "cs.insumos.act.comprarAria": "Cargar compra de {name}",
    "cs.insumos.act.contarAria": "Contar {name}",
    "cs.insumos.menu.aria": "Más acciones de {name}",
    "cs.insumos.menu.contar": "Contar",
    "cs.insumos.menu.perdida": "Anotar pérdida",
    "cs.insumos.menu.corregir": "Corregir a mano",
    "cs.insumos.menu.track": "Controlar el stock",
    "cs.insumos.menu.nombre": "Cambiar nombre",
    "cs.insumos.menu.unidad": "Cambiar cómo se mide",
    "cs.insumos.menu.dejar": "Dejar de controlar",
    "cs.insumos.menu.borrar": "Borrar insumo",
    "cs.insumos.m.hay": "hay {qty}",
    "cs.insumos.m.notTracked": "no controlado",
    "cs.insumos.optional": "(opcional)",
    "cs.insumos.dup": "Ya tenés \"{name}\".",
    "cs.insumos.rel.now": "recién",
    "cs.insumos.rel.min": "hace {n} min",
    "cs.insumos.rel.h": "hace {n} h",
    "cs.insumos.rel.today": "hoy",
    "cs.insumos.rel.yesterday": "ayer",
    "cs.insumos.rel.days": "hace {n} días",
    "cs.insumos.rel.months": "hace {n} meses",
    "cs.insumos.rel.year": "hace un año",
    "cs.insumos.rel.years": "hace {n} años",
    "cs.insumos.per.kg": "el kg",
    "cs.insumos.per.g": "el g",
    "cs.insumos.per.lt": "el litro",
    "cs.insumos.per.ml": "el ml",
    "cs.insumos.per.u": "c/u",
    "cs.insumos.per.doc": "la docena",
    "cs.insumos.unitWord.kg": "kilo",
    "cs.insumos.unitWord.g": "gramo",
    "cs.insumos.unitWord.lt": "litro",
    "cs.insumos.unitWord.ml": "mililitro",
    "cs.insumos.unitWord.u": "unidad",
    "cs.insumos.unitWord.doc": "docena",

    // ── Ficha: precio
    "cs.insumos.ficha.eyebrow": "Insumo",
    "cs.insumos.ficha.compraM": "Compra",
    "cs.insumos.ficha.missingT": "No encontramos este insumo",
    "cs.insumos.ficha.missingB": "Puede que lo hayan borrado.",
    "cs.insumos.ficha.toList": "Ver insumos",
    "cs.insumos.price.title": "Precio",
    "cs.insumos.price.paid": "Pagaste",
    "cs.insumos.price.per": "por",
    "cs.insumos.price.unitAria": "Unidad de lo que compraste",
    "cs.insumos.price.docenas": "docenas",
    "cs.insumos.price.help": "Poné lo que pagaste en total y cuánto vino: la cuenta la hacemos nosotros.",
    "cs.insumos.price.badTotal": "Poné cuánto pagaste en total (un número).",
    "cs.insumos.price.badQty": "Poné cuánto vino (un número mayor a 0).",
    "cs.insumos.price.before": "Antes {plata}",
    "cs.insumos.price.goesUp": "sube {pct}%",
    "cs.insumos.price.goesDown": "baja {pct}%",
    "cs.insumos.price.since": "Desde el {fecha}",
    "cs.insumos.price.sinceToday": "Desde hoy",
    "cs.insumos.price.up": "subió {pct}%",
    "cs.insumos.price.down": "bajó {pct}%",
    "cs.insumos.price.same": "igual",
    "cs.insumos.price.sameAria": "El precio de {name} sigue igual: marcarlo revisado hoy",
    "cs.insumos.price.sameDone": "Listo: {name} sigue a {plata}. Quedó revisado hoy.",
    "cs.insumos.price.keep": "Sigue igual",
    "cs.insumos.price.none": "Todavía no tiene precio: los platos que lo usan quedan incompletos.",
    "cs.insumos.price.save": "Guardar precio",
    "cs.insumos.price.saved": "Precio guardado",
    "cs.insumos.price.savedImpact": "Precio guardado · {name} ahora te deja {plata} menos",
    "cs.insumos.brake.body": "Pasaría de {antes} a {ahora} {por} ({cambio}). ¿Pusiste el total o el precio por {unidad}?",
    "cs.insumos.brake.ok": "Sí, está bien así",
    "cs.insumos.hist.title": "Historial",
    "cs.insumos.hist.titleM": "Historial de precio",
    "cs.insumos.hist.bought": "{qty} por {plata}",

    // ── Ficha: se usa en
    "cs.insumos.uses.title": "Se usa en",
    "cs.insumos.uses.tap": "tocá para abrir",
    "cs.insumos.uses.empty": "Ningún plato lo usa todavía.",
    "cs.insumos.uses.in": "Se usa en {what}",
    "cs.insumos.uses.and": " y ",
    "cs.insumos.uses.p.one": "1 plato",
    "cs.insumos.uses.p.other": "{n} platos",
    "cs.insumos.uses.s.one": "1 preparado",
    "cs.insumos.uses.s.other": "{n} preparados",
    "cs.insumos.uses.broken": "Unidad rota: ahí no cuesta ni descuenta",
    "cs.insumos.uses.via": "en {name}",
    "cs.insumos.uses.prep": "preparado",

    // ── Cambiar cómo se mide
    "cs.insumos.unit.title": "Cambiar cómo se mide",
    "cs.insumos.unit.now": "Hoy se mide por {unidad}.",
    "cs.insumos.unit.by": "Por {unidad}",
    "cs.insumos.unit.ok": "Cambiar",
    "cs.insumos.unit.done": "Listo: ahora se mide por {unidad}.",
    "cs.insumos.unit.trackedT": "Lo estás controlando:",
    "cs.insumos.unit.trackedB": "si cambiás cómo se mide, el saldo se rompe.",
    "cs.insumos.unit.familyT.one": "Está en 1 receta medido en {medida}.",
    "cs.insumos.unit.familyT.other": "Está en {n} recetas medido en {medida}.",
    "cs.insumos.unit.familyB": "Si lo cambiás, esas recetas dejan de costar y de descontar.",
    "cs.insumos.unit.createHint": "Creá otro insumo: \"{name}\".",
    "cs.insumos.unit.create": "Crear el otro insumo",
    "cs.insumos.unit.copyName": "{name} (por {unidad})",
    "cs.insumos.unit.measured.g": "gramos",
    "cs.insumos.unit.measured.ml": "ml",
    "cs.insumos.unit.measured.u": "unidades",
    "cs.insumos.unit.keepRecipes": "Las recetas siguen andando.",
    "cs.insumos.unit.free": "No se usa en recetas ni se controla: lo podés cambiar.",
    "cs.insumos.unit.fixes": "Las recetas que lo usan ya lo miden en {medida}: con este cambio vuelven a costar y a descontar.",
    "cs.insumos.unit.newPrice": "El precio pasa a {plata} {por}.",
    "cs.insumos.unit.priceQ": "¿Cuánto pagás {por}?",
    "cs.insumos.unit.priceHint": "Si no lo sabés, dejalo vacío: queda \"Falta precio\".",

    // ── Borrar insumo · cambiar nombre
    "cs.insumos.del.title": "¿Borrar {name}?",
    "cs.insumos.del.ok": "Borrar",
    "cs.insumos.del.done": "Borraste {name}",
    "cs.insumos.del.trackedT": "Lo estás controlando:",
    "cs.insumos.del.trackedB": "se pierde su saldo.",
    "cs.insumos.del.usedBy.one": "Lo usa 1 receta:",
    "cs.insumos.del.usedBy.other": "Lo usan {n} recetas:",
    "cs.insumos.del.more": "y {n} más",
    "cs.insumos.del.usedB": "Esas recetas quedan sin este ingrediente y su costo baja.",
    "cs.insumos.del.unused": "Ningún plato lo usa. Se borra con su historial de precios.",
    "cs.insumos.rename.title": "Cambiar nombre",
    "cs.insumos.rename.label": "Nombre",

    // ── Insumo nuevo (hoja y editor de preparados)
    "cs.insumos.new.title": "Insumo nuevo",
    "cs.insumos.new.sub": "Algo que comprás para la cocina.",
    "cs.insumos.new.name": "Nombre",
    "cs.insumos.new.namePh": "Ej.: Harina 0000",
    "cs.insumos.new.presets": "Sugerencias",
    "cs.insumos.new.how": "¿Cómo lo comprás?",
    "cs.insumos.new.by.kg": "Por kilo",
    "cs.insumos.new.by.lt": "Por litro",
    "cs.insumos.new.by.u": "Por unidad",
    "cs.insumos.new.price": "Precio",
    "cs.insumos.new.noPrice": "Si no lo sabés, dejalo vacío: queda \"Falta precio\".",
    "cs.insumos.new.track": "Controlar el stock",
    "cs.insumos.new.have": "¿Cuánto tenés ahora?",
    "cs.insumos.new.haveHint": "Si no lo sabés, contalo después.",
    "cs.insumos.new.add": "Agregar",
    "cs.insumos.new.retryHint": "Probá de nuevo.",
    "cs.insumos.new.done": "Agregaste {name}",
    "cs.insumos.new.doneHave": "hay {qty}",
    "cs.insumos.new.doneNoPrice": "Cuando sepas el precio, cargalo en su ficha o con la próxima compra.",
    "cs.insumos.new.another": "Agregar otro",
    "cs.insumos.new.open": "Ver la ficha",
    "cs.insumos.new.ok": "Listo",
    "cs.insumos.new.openDup": "Abrir el que tenés",

    // ── Preparados
    "cs.insumos.prep.sub": "Lo que hacés en la cocina y usás en varios platos: salsas, masas, aderezos.",
    "cs.insumos.prep.new": "Nuevo preparado",
    "cs.insumos.prep.empty.t": "Todavía no tenés preparados",
    "cs.insumos.prep.empty.b": "Armá uno con sus ingredientes y lo que rinde: después lo sumás a los platos como un ingrediente más.",
    "cs.insumos.prep.noName": "(sin nombre)",
    "cs.insumos.prep.lines.one": "1 ingrediente",
    "cs.insumos.prep.lines.other": "{n} ingredientes",
    "cs.insumos.prep.yields": "rinde {qty}",
    "cs.insumos.prep.eyebrow": "Preparado",
    "cs.insumos.prep.newTitle": "Preparado nuevo",
    "cs.insumos.prep.headSub": "Se costea una vez y se usa en varios platos.",
    "cs.insumos.prep.costs": "Te sale",
    "cs.insumos.prep.total": "Todo el preparado: {plata}",
    "cs.insumos.prep.yieldsShort": "rinde {qty}",
    "cs.insumos.prep.name": "Nombre",
    "cs.insumos.prep.namePh": "Ej.: Salsa de tomate",
    "cs.insumos.prep.yield": "¿Cuánto rinde?",
    "cs.insumos.prep.yieldUnit": "En qué rinde",
    "cs.insumos.prep.yieldHint": "Lo que sale de la olla, ya listo.",
    "cs.insumos.prep.badYield": "Poné cuánto rinde (un número mayor a 0).",
    "cs.insumos.prep.unit.kg": "kg",
    "cs.insumos.prep.unit.lt": "litros",
    "cs.insumos.prep.unit.u": "porciones",
    "cs.insumos.prep.per.kg": "el kg",
    "cs.insumos.prep.per.lt": "el litro",
    "cs.insumos.prep.per.u": "la porción",
    "cs.insumos.prep.portion.one": "{n} porción",
    "cs.insumos.prep.portion.other": "{n} porciones",
    "cs.insumos.prep.lines": "¿Qué lleva?",
    "cs.insumos.prep.linesEmpty": "Todavía no tiene ingredientes. Buscalos acá abajo.",
    "cs.insumos.prep.addPh": "Agregar un ingrediente…",
    "cs.insumos.prep.already": "ya está",
    "cs.insumos.prep.create": "Crear \"{name}\"",
    "cs.insumos.prep.createT": "Ingrediente nuevo",
    "cs.insumos.prep.createOk": "Agregar ingrediente",
    "cs.insumos.prep.useDup": "Usar {name}",
    "cs.insumos.prep.amountAria": "Cantidad de {name} ({unit})",
    "cs.insumos.prep.remove": "Sacar {name}",
    "cs.insumos.prep.unused": "Ningún plato lo usa todavía.",
    "cs.insumos.prep.needName": "Ponele un nombre",
    "cs.insumos.prep.saved": "Guardaste {name}",
    "cs.insumos.prep.deleted": "Borraste {name}",
    "cs.insumos.prep.menuAria": "Más acciones del preparado",
    "cs.insumos.prep.del": "Borrar preparado",
    "cs.insumos.prep.delT": "¿Borrar {name}?",
    "cs.insumos.prep.delUsedB": "Esos platos quedan sin este preparado y su costo baja.",
    "cs.insumos.prep.delUnused": "Ningún plato lo usa.",
    "cs.insumos.prep.draftBanner": "Tenés cambios sin guardar en este preparado.",
    "cs.insumos.prep.draftKeep": "Seguir",
    "cs.insumos.prep.draftDiscard": "Descartar",
    "cs.insumos.prep.unitBlockedT.one": "Se usa en 1 receta:",
    "cs.insumos.prep.unitBlockedT.other": "Se usa en {n} recetas:",
    "cs.insumos.prep.unitBlockedB": "lo usan en {medida}. Con otro rinde dejan de costar y de descontar. Hacé uno nuevo con este rinde.",
    "cs.insumos.prep.copy": "Crear uno nuevo así",
    "cs.insumos.prep.copyName": "{name} (en {unidad})",
    "cs.insumos.prep.missingT": "No encontramos este preparado",
    "cs.insumos.prep.toList": "Ver preparados",

    // ── Stock
    "cs.stock.title": "Stock",
    "cs.stock.track.label": "Controlar",
    "cs.stock.track.done": "Ahora controlás {name}. Falta contarlo.",
    "cs.stock.retrack.title": "Volver a controlar {name}",
    "cs.stock.retrack.body": "Ya lo controlaste antes. Desde entonces no se fue descontando: contalo ahora así arranca con el número de hoy.",
    "cs.stock.retrack.q": "¿Cuánto tenés ahora?",
    "cs.stock.retrack.ok": "Empezar a controlar",
    "cs.stock.retrack.done": "Ahora controlás {name}: arranca con {qty}.",
    "cs.stock.off.body.one": "No se controla. Si lo prendés, baja solo con cada venta de 1 plato y el mozo ve \"Agotado\" cuando no queda.",
    "cs.stock.off.body.other": "No se controla. Si lo prendés, baja solo con cada venta de {n} platos y el mozo ve \"Agotado\" cuando no queda.",
    "cs.stock.off.unused": "No se controla. Ningún plato lo usa: sólo bajaría con lo que cargues a mano.",
    "cs.stock.neverCounted": "Lo controlás pero nunca lo contaste: sin ese número no sabemos cuánto hay.",
    "cs.stock.hay": "Hay ahora",
    "cs.stock.worth": "Vale hoy",
    "cs.stock.oversold": "Se vendió de más",
    "cs.stock.countAgain": "contá de nuevo",
    "cs.stock.oversoldHelp": "Se vendió más de lo que contaste: contalo de nuevo para que el número sirva.",
    "cs.stock.oversoldShort": "se vendió de más",
    "cs.stock.stale": "Lo contaste hace más de 4 meses: contalo de nuevo para que el número sirva.",
    "cs.stock.broken": "Una receta lo pide en una unidad que no se puede pasar: el salón no lo descuenta. Mirá \"Se usa en\".",
    "cs.stock.noSales": "No pudimos leer las ventas: este número todavía no resta lo vendido.",
    "cs.stock.noSalesShort": "Sin ventas",
    "cs.stock.ledger.since": "Desde el conteo del {fecha} ({when}):",
    "cs.stock.ledger.sinceToday": "Desde el conteo de hoy:",
    "cs.stock.ledger.count": "Contaste",
    "cs.stock.ledger.bought": "+ Compraste",
    "cs.stock.ledger.sold": "− Vendiste",
    "cs.stock.ledger.waste": "− Perdiste",
    "cs.stock.ledger.adjusted": "± Corregiste",
    "cs.stock.ledger.sum": "= Hay",
    "cs.stock.ledger.deletedDish": "(plato borrado)",
    "cs.stock.count.again": "¿Contaste recién?",
    "cs.stock.count.first": "¿Cuánto tenés ahora?",
    "cs.stock.count.doneFirst": "Listo: hay {qty}",
    "cs.stock.count.doneSame": "Listo: {qty}, justo lo que calculábamos.",
    "cs.stock.count.doneMissing": "Listo: {qty}. Calculábamos {exp}: faltaron {diff} ({plata}).",
    "cs.stock.count.doneExtra": "Listo: {qty}. Calculábamos {exp}: sobraron {diff} ({plata}).",
    "cs.stock.min.label": "Avisame con menos de",
    "cs.stock.min.aria": "Avisame con menos de ({unit}): {name}",
    "cs.stock.min.saved": "Guardado",
    "cs.stock.min.bad": "Poné un número (con coma si tiene decimales).",
    "cs.stock.min.echo": "Con menos de {qty}, el mozo va a ver cuántos quedan (por ejemplo, \"Quedan 3\").",
    "cs.stock.min.help": "Con menos de {qty}, el mozo ve cuántos quedan (por ejemplo, \"Quedan 3\").",
    "cs.stock.min.none": "Sin aviso, el mozo sólo ve \"Agotado\", nunca cuántos quedan.",
    "cs.stock.movs.title": "Movimientos (compras, conteos, pérdidas)",
    "cs.stock.movs.expected": "calculábamos {qty}",
    "cs.stock.movs.more": "Ver {n} más",
    "cs.stock.movs.type.count": "Conteo",
    "cs.stock.movs.type.purchase": "Compra",
    "cs.stock.movs.type.waste": "Pérdida",
    "cs.stock.movs.type.adjust": "Corrección",
    "cs.stock.movs.type.other": "Movimiento",
    "cs.stock.dejar.title": "¿Dejar de controlar {name}?",
    "cs.stock.dejar.body": "Deja de bajar con las ventas y el mozo ya no ve \"Agotado\". El precio y las recetas quedan igual.",
    "cs.stock.dejar.hay": "Hoy hay {qty}",
    "cs.stock.dejar.again": "Si después lo volvés a controlar, contalo de nuevo.",
    "cs.stock.dejar.ok": "Dejar de controlar",
    "cs.stock.dejar.done": "Ya no controlás {name}",
    "cs.stock.fix.title": "Corregir a mano · {name}",
    "cs.stock.fix.help": "Para cuando sabés el número exacto y no querés contar todo. Si lo contaste, mejor usá \"¿Contaste recién?\": te muestra la diferencia en plata.",
    "cs.stock.fix.how": "Sumar o restar",
    "cs.stock.fix.add": "Sumar",
    "cs.stock.fix.sub": "Restar",
    "cs.stock.fix.qty": "Cantidad",
    "cs.stock.fix.after": "Hay {from} → va a quedar {to}",
    "cs.stock.fix.afterOver": "Va a quedar {to}",
    "cs.stock.fix.note": "¿Por qué?",
    "cs.stock.fix.notePh": "Ej.: me equivoqué al cargar la compra",
    "cs.stock.fix.ok": "Guardar corrección",
    "cs.stock.fix.done": "Corrección guardada",
    "cs.stock.err.ordersT": "No pudimos leer las ventas:",
    "cs.stock.err.ordersB": "el stock puede estar inflado.",
    "cs.stock.err.stale": "Mostramos lo que leímos {when}.",
    "cs.stock.err.loadT": "No pudimos leer el stock.",
    "cs.stock.err.loadB": "Revisá la conexión y recargá la página.",
    "cs.stock.err.reload": "Recargar",
    "cs.stock.sales.read": "Ventas leídas {when}",
    "cs.stock.sales.reading": "Leyendo las ventas…",
    "cs.stock.sales.refresh": "Actualizar",
    "cs.stock.pack": "Con Gestión del local, el stock baja solo con cada venta y el mozo ve \"Agotado\".",
  },
  en: {
    "cs.insumos.eyebrow": "What you buy",
    "cs.insumos.sub": "The price works for every dish that uses it.",
    "cs.insumos.subStock": "Stock goes down on its own with every sale.",
    "cs.insumos.head.precios": "Review prices",
    "cs.insumos.head.contar": "Count",
    "cs.insumos.head.compra": "Log a purchase",
    "cs.insumos.seg.aria": "Show supplies or preps",
    "cs.insumos.seg.preparados": "Preps",
    "cs.insumos.search.ph": "Search or add a supply…",
    "cs.insumos.search.prepPh": "Search preps…",
    "cs.insumos.chips.aria": "Filter supplies",
    "cs.insumos.chips.todos": "All",
    "cs.insumos.chips.controlados": "Tracked",
    "cs.insumos.chips.reponer": "To restock",
    "cs.insumos.chips.sincontar": "Not counted",
    "cs.insumos.chips.sinprecio": "No price",
    "cs.insumos.kpi.value": "Stock value",
    "cs.insumos.kpi.reponer": "To restock",
    "cs.insumos.kpi.out.one": "{n} out of stock",
    "cs.insumos.kpi.out.other": "{n} out of stock",
    "cs.insumos.kpi.sincontar": "Not counted",
    "cs.insumos.kpi.last": "Last count",
    "cs.insumos.kpi.never": "Never",
    "cs.insumos.kpi.sinprecio": "No price",
    "cs.insumos.kpi.mValue": "in stock",
    "cs.insumos.kpi.mReponer": "{n} to restock",
    "cs.insumos.kpi.mSinContar": "{n} not counted",
    "cs.insumos.kpi.mLast": "counted {when}",
    "cs.insumos.kpi.mNever": "never counted",
    "cs.insumos.noPrice.one": "1 supply has no price:",
    "cs.insumos.noPrice.other": "{n} supplies have no price:",
    "cs.insumos.noPrice.body": "the dishes that use them are incomplete.",
    "cs.insumos.noPrice.see": "See which",
    "cs.insumos.resume.t": "Step 2 is left:",
    "cs.insumos.resume.b": "count what you have. Without that number we don't know how much there is and the waiter sees nothing.",
    "cs.insumos.resume.go": "Continue",
    "cs.insumos.bulk.compra.one": "Log a purchase of this one",
    "cs.insumos.bulk.compra.other": "Log a purchase of these {n}",
    "cs.insumos.bulk.contar": "Count",
    "cs.insumos.add.q": "Add \"{name}\"",
    "cs.insumos.add.qSub": "as a new supply",
    "cs.insumos.empty.t": "You haven't added supplies yet",
    "cs.insumos.empty.b": "They're what you buy: flour, mozzarella, oil. They're added when you build a dish's recipe, or add them here.",
    "cs.insumos.empty.add": "Add a supply",
    "cs.insumos.none.q": "We couldn't find \"{q}\".",
    "cs.insumos.none.f": "No supplies match this filter.",
    "cs.insumos.none.all": "See all",
    "cs.insumos.col.insumo": "Supply",
    "cs.insumos.col.precio": "Price",
    "cs.insumos.col.uso": "Used in",
    "cs.insumos.col.hay": "On hand",
    "cs.insumos.col.min": "Alert me at",
    "cs.insumos.col.estado": "Status",
    "cs.insumos.col.precioDe": "Price from",
    "cs.insumos.priceAge": "price from {when}",
    "cs.insumos.uso.one": "1 dish",
    "cs.insumos.uso.other": "{n} dishes",
    "cs.insumos.uso.prepOne": "in 1 prep",
    "cs.insumos.uso.prepOther": "in {n} preps",
    "cs.insumos.uso.none": "none",
    "cs.insumos.act.comprar": "Buy",
    "cs.insumos.act.contar": "Count",
    "cs.insumos.act.comprarAria": "Log a purchase of {name}",
    "cs.insumos.act.contarAria": "Count {name}",
    "cs.insumos.menu.aria": "More actions for {name}",
    "cs.insumos.menu.contar": "Count",
    "cs.insumos.menu.perdida": "Log a loss",
    "cs.insumos.menu.corregir": "Fix by hand",
    "cs.insumos.menu.track": "Track stock",
    "cs.insumos.menu.nombre": "Rename",
    "cs.insumos.menu.unidad": "Change how it's measured",
    "cs.insumos.menu.dejar": "Stop tracking",
    "cs.insumos.menu.borrar": "Delete supply",
    "cs.insumos.m.hay": "{qty} on hand",
    "cs.insumos.m.notTracked": "not tracked",
    "cs.insumos.optional": "(optional)",
    "cs.insumos.dup": "You already have \"{name}\".",
    "cs.insumos.rel.now": "just now",
    "cs.insumos.rel.min": "{n} min ago",
    "cs.insumos.rel.h": "{n} h ago",
    "cs.insumos.rel.today": "today",
    "cs.insumos.rel.yesterday": "yesterday",
    "cs.insumos.rel.days": "{n} days ago",
    "cs.insumos.rel.months": "{n} months ago",
    "cs.insumos.rel.year": "a year ago",
    "cs.insumos.rel.years": "{n} years ago",
    "cs.insumos.per.kg": "per kg",
    "cs.insumos.per.g": "per g",
    "cs.insumos.per.lt": "per liter",
    "cs.insumos.per.ml": "per ml",
    "cs.insumos.per.u": "each",
    "cs.insumos.per.doc": "per dozen",
    "cs.insumos.unitWord.kg": "kilo",
    "cs.insumos.unitWord.g": "gram",
    "cs.insumos.unitWord.lt": "liter",
    "cs.insumos.unitWord.ml": "milliliter",
    "cs.insumos.unitWord.u": "unit",
    "cs.insumos.unitWord.doc": "dozen",

    "cs.insumos.ficha.eyebrow": "Supply",
    "cs.insumos.ficha.compraM": "Purchase",
    "cs.insumos.ficha.missingT": "We couldn't find this supply",
    "cs.insumos.ficha.missingB": "It may have been deleted.",
    "cs.insumos.ficha.toList": "See supplies",
    "cs.insumos.price.title": "Price",
    "cs.insumos.price.paid": "You paid",
    "cs.insumos.price.per": "for",
    "cs.insumos.price.unitAria": "Unit of what you bought",
    "cs.insumos.price.docenas": "dozens",
    "cs.insumos.price.help": "Enter what you paid in total and how much came: we do the math.",
    "cs.insumos.price.badTotal": "Enter how much you paid in total (a number).",
    "cs.insumos.price.badQty": "Enter how much came (a number above 0).",
    "cs.insumos.price.before": "Before {plata}",
    "cs.insumos.price.goesUp": "up {pct}%",
    "cs.insumos.price.goesDown": "down {pct}%",
    "cs.insumos.price.since": "Since {fecha}",
    "cs.insumos.price.sinceToday": "Since today",
    "cs.insumos.price.up": "went up {pct}%",
    "cs.insumos.price.down": "went down {pct}%",
    "cs.insumos.price.same": "same",
    "cs.insumos.price.sameAria": "{name}'s price is still the same: mark it checked today",
    "cs.insumos.price.sameDone": "Done: {name} is still {plata}. Marked as checked today.",
    "cs.insumos.price.keep": "Still the same",
    "cs.insumos.price.none": "No price yet: the dishes that use it are incomplete.",
    "cs.insumos.price.save": "Save price",
    "cs.insumos.price.saved": "Price saved",
    "cs.insumos.price.savedImpact": "Price saved · {name} now leaves you {plata} less",
    "cs.insumos.brake.body": "It would go from {antes} to {ahora} {por} ({cambio}). Did you enter the total or the price per {unidad}?",
    "cs.insumos.brake.ok": "Yes, that's right",
    "cs.insumos.hist.title": "History",
    "cs.insumos.hist.titleM": "Price history",
    "cs.insumos.hist.bought": "{qty} for {plata}",

    "cs.insumos.uses.title": "Used in",
    "cs.insumos.uses.tap": "tap to open",
    "cs.insumos.uses.empty": "No dish uses it yet.",
    "cs.insumos.uses.in": "Used in {what}",
    "cs.insumos.uses.and": " and ",
    "cs.insumos.uses.p.one": "1 dish",
    "cs.insumos.uses.p.other": "{n} dishes",
    "cs.insumos.uses.s.one": "1 prep",
    "cs.insumos.uses.s.other": "{n} preps",
    "cs.insumos.uses.broken": "Broken unit: no cost and no deduction there",
    "cs.insumos.uses.via": "in {name}",
    "cs.insumos.uses.prep": "prep",

    "cs.insumos.unit.title": "Change how it's measured",
    "cs.insumos.unit.now": "Today it's measured per {unidad}.",
    "cs.insumos.unit.by": "Per {unidad}",
    "cs.insumos.unit.ok": "Change",
    "cs.insumos.unit.done": "Done: now it's measured per {unidad}.",
    "cs.insumos.unit.trackedT": "You're tracking it:",
    "cs.insumos.unit.trackedB": "if you change how it's measured, the balance breaks.",
    "cs.insumos.unit.familyT.one": "It's in 1 recipe measured in {medida}.",
    "cs.insumos.unit.familyT.other": "It's in {n} recipes measured in {medida}.",
    "cs.insumos.unit.familyB": "If you change it, those recipes stop costing and deducting.",
    "cs.insumos.unit.createHint": "Create another supply: \"{name}\".",
    "cs.insumos.unit.create": "Create the other supply",
    "cs.insumos.unit.copyName": "{name} (per {unidad})",
    "cs.insumos.unit.measured.g": "grams",
    "cs.insumos.unit.measured.ml": "ml",
    "cs.insumos.unit.measured.u": "units",
    "cs.insumos.unit.keepRecipes": "Recipes keep working.",
    "cs.insumos.unit.free": "It's not in any recipe and not tracked: you can change it.",
    "cs.insumos.unit.fixes": "The recipes that use it already measure it in {medida}: with this change they cost and deduct again.",
    "cs.insumos.unit.newPrice": "The price becomes {plata} {por}.",
    "cs.insumos.unit.priceQ": "How much do you pay {por}?",
    "cs.insumos.unit.priceHint": "If you don't know, leave it empty: it stays as \"No price\".",

    "cs.insumos.del.title": "Delete {name}?",
    "cs.insumos.del.ok": "Delete",
    "cs.insumos.del.done": "You deleted {name}",
    "cs.insumos.del.trackedT": "You're tracking it:",
    "cs.insumos.del.trackedB": "its balance will be lost.",
    "cs.insumos.del.usedBy.one": "1 recipe uses it:",
    "cs.insumos.del.usedBy.other": "{n} recipes use it:",
    "cs.insumos.del.more": "and {n} more",
    "cs.insumos.del.usedB": "Those recipes lose this ingredient and their cost goes down.",
    "cs.insumos.del.unused": "No dish uses it. It's deleted along with its price history.",
    "cs.insumos.rename.title": "Rename",
    "cs.insumos.rename.label": "Name",

    "cs.insumos.new.title": "New supply",
    "cs.insumos.new.sub": "Something you buy for the kitchen.",
    "cs.insumos.new.name": "Name",
    "cs.insumos.new.namePh": "E.g.: 0000 flour",
    "cs.insumos.new.presets": "Suggestions",
    "cs.insumos.new.how": "How do you buy it?",
    "cs.insumos.new.by.kg": "By the kilo",
    "cs.insumos.new.by.lt": "By the liter",
    "cs.insumos.new.by.u": "By the unit",
    "cs.insumos.new.price": "Price",
    "cs.insumos.new.noPrice": "If you don't know, leave it empty: it stays as \"No price\".",
    "cs.insumos.new.track": "Track stock",
    "cs.insumos.new.have": "How much do you have now?",
    "cs.insumos.new.haveHint": "If you don't know, count it later.",
    "cs.insumos.new.add": "Add",
    "cs.insumos.new.retryHint": "Try again.",
    "cs.insumos.new.done": "You added {name}",
    "cs.insumos.new.doneHave": "{qty} on hand",
    "cs.insumos.new.doneNoPrice": "When you know the price, enter it on its page or with the next purchase.",
    "cs.insumos.new.another": "Add another",
    "cs.insumos.new.open": "Open it",
    "cs.insumos.new.ok": "Done",
    "cs.insumos.new.openDup": "Open the one you have",

    "cs.insumos.prep.sub": "What you make in the kitchen and use in several dishes: sauces, doughs, dressings.",
    "cs.insumos.prep.new": "New prep",
    "cs.insumos.prep.empty.t": "You don't have preps yet",
    "cs.insumos.prep.empty.b": "Build one with its ingredients and its yield: then add it to dishes like any other ingredient.",
    "cs.insumos.prep.noName": "(no name)",
    "cs.insumos.prep.lines.one": "1 ingredient",
    "cs.insumos.prep.lines.other": "{n} ingredients",
    "cs.insumos.prep.yields": "yields {qty}",
    "cs.insumos.prep.eyebrow": "Prep",
    "cs.insumos.prep.newTitle": "New prep",
    "cs.insumos.prep.headSub": "Cost it once, use it in several dishes.",
    "cs.insumos.prep.costs": "It costs you",
    "cs.insumos.prep.total": "The whole batch: {plata}",
    "cs.insumos.prep.yieldsShort": "yields {qty}",
    "cs.insumos.prep.name": "Name",
    "cs.insumos.prep.namePh": "E.g.: Tomato sauce",
    "cs.insumos.prep.yield": "How much does it yield?",
    "cs.insumos.prep.yieldUnit": "Yield unit",
    "cs.insumos.prep.yieldHint": "What comes out of the pot, ready to use.",
    "cs.insumos.prep.badYield": "Enter the yield (a number above 0).",
    "cs.insumos.prep.unit.kg": "kg",
    "cs.insumos.prep.unit.lt": "liters",
    "cs.insumos.prep.unit.u": "portions",
    "cs.insumos.prep.per.kg": "per kg",
    "cs.insumos.prep.per.lt": "per liter",
    "cs.insumos.prep.per.u": "per portion",
    "cs.insumos.prep.portion.one": "{n} portion",
    "cs.insumos.prep.portion.other": "{n} portions",
    "cs.insumos.prep.lines": "What goes in it?",
    "cs.insumos.prep.linesEmpty": "No ingredients yet. Search for them below.",
    "cs.insumos.prep.addPh": "Add an ingredient…",
    "cs.insumos.prep.already": "already in",
    "cs.insumos.prep.create": "Create \"{name}\"",
    "cs.insumos.prep.createT": "New ingredient",
    "cs.insumos.prep.createOk": "Add ingredient",
    "cs.insumos.prep.useDup": "Use {name}",
    "cs.insumos.prep.amountAria": "Amount of {name} ({unit})",
    "cs.insumos.prep.remove": "Remove {name}",
    "cs.insumos.prep.unused": "No dish uses it yet.",
    "cs.insumos.prep.needName": "Give it a name",
    "cs.insumos.prep.saved": "You saved {name}",
    "cs.insumos.prep.deleted": "You deleted {name}",
    "cs.insumos.prep.menuAria": "More prep actions",
    "cs.insumos.prep.del": "Delete prep",
    "cs.insumos.prep.delT": "Delete {name}?",
    "cs.insumos.prep.delUsedB": "Those dishes lose this prep and their cost goes down.",
    "cs.insumos.prep.delUnused": "No dish uses it.",
    "cs.insumos.prep.draftBanner": "You have unsaved changes in this prep.",
    "cs.insumos.prep.draftKeep": "Keep",
    "cs.insumos.prep.draftDiscard": "Discard",
    "cs.insumos.prep.unitBlockedT.one": "It's used in 1 recipe:",
    "cs.insumos.prep.unitBlockedT.other": "It's used in {n} recipes:",
    "cs.insumos.prep.unitBlockedB": "they use it in {medida}. With another yield they stop costing and deducting. Make a new one with this yield.",
    "cs.insumos.prep.copy": "Create a new one like this",
    "cs.insumos.prep.copyName": "{name} (in {unidad})",
    "cs.insumos.prep.missingT": "We couldn't find this prep",
    "cs.insumos.prep.toList": "See preps",

    "cs.stock.title": "Stock",
    "cs.stock.track.label": "Track",
    "cs.stock.track.done": "Now you track {name}. It still needs a count.",
    "cs.stock.retrack.title": "Track {name} again",
    "cs.stock.retrack.body": "You tracked it before. Since then it hasn't been deducted: count it now so it starts from today's number.",
    "cs.stock.retrack.q": "How much do you have now?",
    "cs.stock.retrack.ok": "Start tracking",
    "cs.stock.retrack.done": "Now you track {name}: it starts at {qty}.",
    "cs.stock.off.body.one": "Not tracked. If you turn it on, it goes down with every sale of 1 dish and the waiter sees \"Sold out\" when it runs out.",
    "cs.stock.off.body.other": "Not tracked. If you turn it on, it goes down with every sale of {n} dishes and the waiter sees \"Sold out\" when it runs out.",
    "cs.stock.off.unused": "Not tracked. No dish uses it: it would only go down with what you enter by hand.",
    "cs.stock.neverCounted": "You track it but never counted it: without that number we don't know how much there is.",
    "cs.stock.hay": "On hand",
    "cs.stock.worth": "Worth today",
    "cs.stock.oversold": "Sold more than you had",
    "cs.stock.countAgain": "count it again",
    "cs.stock.oversoldHelp": "More was sold than you counted: count it again so the number is useful.",
    "cs.stock.oversoldShort": "oversold",
    "cs.stock.stale": "You counted it more than 4 months ago: count it again so the number is useful.",
    "cs.stock.broken": "A recipe asks for it in a unit we can't convert: the floor doesn't deduct it. Check \"Used in\".",
    "cs.stock.noSales": "We couldn't read sales: this number doesn't subtract what was sold yet.",
    "cs.stock.noSalesShort": "No sales",
    "cs.stock.ledger.since": "Since the count on {fecha} ({when}):",
    "cs.stock.ledger.sinceToday": "Since today's count:",
    "cs.stock.ledger.count": "You counted",
    "cs.stock.ledger.bought": "+ You bought",
    "cs.stock.ledger.sold": "− You sold",
    "cs.stock.ledger.waste": "− You lost",
    "cs.stock.ledger.adjusted": "± You fixed",
    "cs.stock.ledger.sum": "= On hand",
    "cs.stock.ledger.deletedDish": "(deleted dish)",
    "cs.stock.count.again": "Just counted?",
    "cs.stock.count.first": "How much do you have now?",
    "cs.stock.count.doneFirst": "Done: {qty} on hand",
    "cs.stock.count.doneSame": "Done: {qty}, exactly what we calculated.",
    "cs.stock.count.doneMissing": "Done: {qty}. We calculated {exp}: {diff} missing ({plata}).",
    "cs.stock.count.doneExtra": "Done: {qty}. We calculated {exp}: {diff} extra ({plata}).",
    "cs.stock.min.label": "Alert me below",
    "cs.stock.min.aria": "Alert me below ({unit}): {name}",
    "cs.stock.min.saved": "Saved",
    "cs.stock.min.bad": "Enter a number.",
    "cs.stock.min.echo": "Below {qty}, the waiter will see how many are left (for example, \"3 left\").",
    "cs.stock.min.help": "Below {qty}, the waiter sees how many are left (for example, \"3 left\").",
    "cs.stock.min.none": "No alert: the waiter only sees \"Sold out\", never how many are left.",
    "cs.stock.movs.title": "Movements (purchases, counts, losses)",
    "cs.stock.movs.expected": "we calculated {qty}",
    "cs.stock.movs.more": "See {n} more",
    "cs.stock.movs.type.count": "Count",
    "cs.stock.movs.type.purchase": "Purchase",
    "cs.stock.movs.type.waste": "Loss",
    "cs.stock.movs.type.adjust": "Fix",
    "cs.stock.movs.type.other": "Movement",
    "cs.stock.dejar.title": "Stop tracking {name}?",
    "cs.stock.dejar.body": "It stops going down with sales and the waiter no longer sees \"Sold out\". Price and recipes stay the same.",
    "cs.stock.dejar.hay": "Today there's {qty}",
    "cs.stock.dejar.again": "If you track it again later, count it again.",
    "cs.stock.dejar.ok": "Stop tracking",
    "cs.stock.dejar.done": "You no longer track {name}",
    "cs.stock.fix.title": "Fix by hand · {name}",
    "cs.stock.fix.help": "For when you know the exact number and don't want to count everything. If you counted it, better use \"Just counted?\": it shows you the difference in money.",
    "cs.stock.fix.how": "Add or subtract",
    "cs.stock.fix.add": "Add",
    "cs.stock.fix.sub": "Subtract",
    "cs.stock.fix.qty": "Amount",
    "cs.stock.fix.after": "There's {from} → it will be {to}",
    "cs.stock.fix.afterOver": "It will be {to}",
    "cs.stock.fix.note": "Why?",
    "cs.stock.fix.notePh": "E.g.: I made a mistake entering the purchase",
    "cs.stock.fix.ok": "Save fix",
    "cs.stock.fix.done": "Fix saved",
    "cs.stock.err.ordersT": "We couldn't read sales:",
    "cs.stock.err.ordersB": "stock may be inflated.",
    "cs.stock.err.stale": "Showing what we read {when}.",
    "cs.stock.err.loadT": "We couldn't read the stock.",
    "cs.stock.err.loadB": "Check your connection and reload the page.",
    "cs.stock.err.reload": "Reload",
    "cs.stock.sales.read": "Sales read {when}",
    "cs.stock.sales.reading": "Reading sales…",
    "cs.stock.sales.refresh": "Refresh",
    "cs.stock.pack": "With Store Management, stock goes down on its own with every sale and the waiter sees \"Sold out\".",
  },
  pt: {
    "cs.insumos.eyebrow": "O que você compra",
    "cs.insumos.sub": "O preço vale para todos os pratos que o usam.",
    "cs.insumos.subStock": "O estoque baixa sozinho a cada venda.",
    "cs.insumos.head.precios": "Revisar preços",
    "cs.insumos.head.contar": "Contar",
    "cs.insumos.head.compra": "Registrar compra",
    "cs.insumos.seg.aria": "Ver insumos ou preparos",
    "cs.insumos.seg.preparados": "Preparos",
    "cs.insumos.search.ph": "Buscar ou adicionar insumo…",
    "cs.insumos.search.prepPh": "Buscar preparo…",
    "cs.insumos.chips.aria": "Filtrar insumos",
    "cs.insumos.chips.todos": "Todos",
    "cs.insumos.chips.controlados": "Controlados",
    "cs.insumos.chips.reponer": "Para repor",
    "cs.insumos.chips.sincontar": "Sem contagem",
    "cs.insumos.chips.sinprecio": "Sem preço",
    "cs.insumos.kpi.value": "Em mercadoria",
    "cs.insumos.kpi.reponer": "Para repor",
    "cs.insumos.kpi.out.one": "{n} sem estoque",
    "cs.insumos.kpi.out.other": "{n} sem estoque",
    "cs.insumos.kpi.sincontar": "Sem contagem",
    "cs.insumos.kpi.last": "Última contagem",
    "cs.insumos.kpi.never": "Nunca",
    "cs.insumos.kpi.sinprecio": "Sem preço",
    "cs.insumos.kpi.mValue": "em mercadoria",
    "cs.insumos.kpi.mReponer": "{n} para repor",
    "cs.insumos.kpi.mSinContar": "{n} sem contagem",
    "cs.insumos.kpi.mLast": "contou {when}",
    "cs.insumos.kpi.mNever": "nunca contou",
    "cs.insumos.noPrice.one": "1 insumo sem preço:",
    "cs.insumos.noPrice.other": "{n} insumos sem preço:",
    "cs.insumos.noPrice.body": "os pratos que os usam ficam incompletos.",
    "cs.insumos.noPrice.see": "Ver quais",
    "cs.insumos.resume.t": "Falta o passo 2:",
    "cs.insumos.resume.b": "contar o que você tem. Sem esse número não sabemos quanto há e o garçom não vê nada.",
    "cs.insumos.resume.go": "Continuar",
    "cs.insumos.bulk.compra.one": "Registrar compra deste",
    "cs.insumos.bulk.compra.other": "Registrar compra destes {n}",
    "cs.insumos.bulk.contar": "Contar",
    "cs.insumos.add.q": "Adicionar \"{name}\"",
    "cs.insumos.add.qSub": "como insumo novo",
    "cs.insumos.empty.t": "Você ainda não cadastrou insumos",
    "cs.insumos.empty.b": "São o que você compra: a farinha, a muçarela, o óleo. Entram sozinhos quando você monta a receita de um prato, ou adicione aqui.",
    "cs.insumos.empty.add": "Adicionar um insumo",
    "cs.insumos.none.q": "Não encontramos \"{q}\".",
    "cs.insumos.none.f": "Não há insumos com este filtro.",
    "cs.insumos.none.all": "Ver todos",
    "cs.insumos.col.insumo": "Insumo",
    "cs.insumos.col.precio": "Preço",
    "cs.insumos.col.uso": "Uso",
    "cs.insumos.col.hay": "Tem agora",
    "cs.insumos.col.min": "Avise com",
    "cs.insumos.col.estado": "Estado",
    "cs.insumos.col.precioDe": "Preço de",
    "cs.insumos.priceAge": "preço: {when}",
    "cs.insumos.uso.one": "1 prato",
    "cs.insumos.uso.other": "{n} pratos",
    "cs.insumos.uso.prepOne": "em 1 preparo",
    "cs.insumos.uso.prepOther": "em {n} preparos",
    "cs.insumos.uso.none": "nenhum",
    "cs.insumos.act.comprar": "Comprar",
    "cs.insumos.act.contar": "Contar",
    "cs.insumos.act.comprarAria": "Registrar compra de {name}",
    "cs.insumos.act.contarAria": "Contar {name}",
    "cs.insumos.menu.aria": "Mais ações de {name}",
    "cs.insumos.menu.contar": "Contar",
    "cs.insumos.menu.perdida": "Anotar perda",
    "cs.insumos.menu.corregir": "Corrigir à mão",
    "cs.insumos.menu.track": "Controlar o estoque",
    "cs.insumos.menu.nombre": "Mudar o nome",
    "cs.insumos.menu.unidad": "Mudar como se mede",
    "cs.insumos.menu.dejar": "Deixar de controlar",
    "cs.insumos.menu.borrar": "Apagar insumo",
    "cs.insumos.m.hay": "tem {qty}",
    "cs.insumos.m.notTracked": "não controlado",
    "cs.insumos.optional": "(opcional)",
    "cs.insumos.dup": "Você já tem \"{name}\".",
    "cs.insumos.rel.now": "agora mesmo",
    "cs.insumos.rel.min": "há {n} min",
    "cs.insumos.rel.h": "há {n} h",
    "cs.insumos.rel.today": "hoje",
    "cs.insumos.rel.yesterday": "ontem",
    "cs.insumos.rel.days": "há {n} dias",
    "cs.insumos.rel.months": "há {n} meses",
    "cs.insumos.rel.year": "há um ano",
    "cs.insumos.rel.years": "há {n} anos",
    "cs.insumos.per.kg": "o kg",
    "cs.insumos.per.g": "o g",
    "cs.insumos.per.lt": "o litro",
    "cs.insumos.per.ml": "o ml",
    "cs.insumos.per.u": "cada",
    "cs.insumos.per.doc": "a dúzia",
    "cs.insumos.unitWord.kg": "quilo",
    "cs.insumos.unitWord.g": "grama",
    "cs.insumos.unitWord.lt": "litro",
    "cs.insumos.unitWord.ml": "mililitro",
    "cs.insumos.unitWord.u": "unidade",
    "cs.insumos.unitWord.doc": "dúzia",

    "cs.insumos.ficha.eyebrow": "Insumo",
    "cs.insumos.ficha.compraM": "Compra",
    "cs.insumos.ficha.missingT": "Não encontramos este insumo",
    "cs.insumos.ficha.missingB": "Pode ser que tenha sido apagado.",
    "cs.insumos.ficha.toList": "Ver insumos",
    "cs.insumos.price.title": "Preço",
    "cs.insumos.price.paid": "Você pagou",
    "cs.insumos.price.per": "por",
    "cs.insumos.price.unitAria": "Unidade do que você comprou",
    "cs.insumos.price.docenas": "dúzias",
    "cs.insumos.price.help": "Coloque o que você pagou no total e quanto veio: a conta é com a gente.",
    "cs.insumos.price.badTotal": "Coloque quanto você pagou no total (um número).",
    "cs.insumos.price.badQty": "Coloque quanto veio (um número maior que 0).",
    "cs.insumos.price.before": "Antes {plata}",
    "cs.insumos.price.goesUp": "sobe {pct}%",
    "cs.insumos.price.goesDown": "baixa {pct}%",
    "cs.insumos.price.since": "Desde {fecha}",
    "cs.insumos.price.sinceToday": "Desde hoje",
    "cs.insumos.price.up": "subiu {pct}%",
    "cs.insumos.price.down": "baixou {pct}%",
    "cs.insumos.price.same": "igual",
    "cs.insumos.price.sameAria": "O preço de {name} continua igual: marcar como revisado hoje",
    "cs.insumos.price.sameDone": "Pronto: {name} continua a {plata}. Ficou revisado hoje.",
    "cs.insumos.price.keep": "Continua igual",
    "cs.insumos.price.none": "Ainda sem preço: os pratos que o usam ficam incompletos.",
    "cs.insumos.price.save": "Salvar preço",
    "cs.insumos.price.saved": "Preço salvo",
    "cs.insumos.price.savedImpact": "Preço salvo · {name} agora te deixa {plata} a menos",
    "cs.insumos.brake.body": "Passaria de {antes} para {ahora} {por} ({cambio}). Você colocou o total ou o preço por {unidad}?",
    "cs.insumos.brake.ok": "Sim, está certo assim",
    "cs.insumos.hist.title": "Histórico",
    "cs.insumos.hist.titleM": "Histórico de preço",
    "cs.insumos.hist.bought": "{qty} por {plata}",

    "cs.insumos.uses.title": "Usado em",
    "cs.insumos.uses.tap": "toque para abrir",
    "cs.insumos.uses.empty": "Nenhum prato usa ainda.",
    "cs.insumos.uses.in": "Usado em {what}",
    "cs.insumos.uses.and": " e ",
    "cs.insumos.uses.p.one": "1 prato",
    "cs.insumos.uses.p.other": "{n} pratos",
    "cs.insumos.uses.s.one": "1 preparo",
    "cs.insumos.uses.s.other": "{n} preparos",
    "cs.insumos.uses.broken": "Unidade quebrada: ali não custa nem desconta",
    "cs.insumos.uses.via": "em {name}",
    "cs.insumos.uses.prep": "preparo",

    "cs.insumos.unit.title": "Mudar como se mede",
    "cs.insumos.unit.now": "Hoje se mede por {unidad}.",
    "cs.insumos.unit.by": "Por {unidad}",
    "cs.insumos.unit.ok": "Mudar",
    "cs.insumos.unit.done": "Pronto: agora se mede por {unidad}.",
    "cs.insumos.unit.trackedT": "Você está controlando:",
    "cs.insumos.unit.trackedB": "se mudar como se mede, o saldo quebra.",
    "cs.insumos.unit.familyT.one": "Está em 1 receita medido em {medida}.",
    "cs.insumos.unit.familyT.other": "Está em {n} receitas medido em {medida}.",
    "cs.insumos.unit.familyB": "Se mudar, essas receitas deixam de custar e de descontar.",
    "cs.insumos.unit.createHint": "Crie outro insumo: \"{name}\".",
    "cs.insumos.unit.create": "Criar o outro insumo",
    "cs.insumos.unit.copyName": "{name} (por {unidad})",
    "cs.insumos.unit.measured.g": "gramas",
    "cs.insumos.unit.measured.ml": "ml",
    "cs.insumos.unit.measured.u": "unidades",
    "cs.insumos.unit.keepRecipes": "As receitas continuam funcionando.",
    "cs.insumos.unit.free": "Não está em receitas nem é controlado: você pode mudar.",
    "cs.insumos.unit.fixes": "As receitas que o usam já o medem em {medida}: com esta mudança voltam a custar e a descontar.",
    "cs.insumos.unit.newPrice": "O preço passa a {plata} {por}.",
    "cs.insumos.unit.priceQ": "Quanto você paga {por}?",
    "cs.insumos.unit.priceHint": "Se não souber, deixe vazio: fica \"Falta preço\".",

    "cs.insumos.del.title": "Apagar {name}?",
    "cs.insumos.del.ok": "Apagar",
    "cs.insumos.del.done": "Você apagou {name}",
    "cs.insumos.del.trackedT": "Você está controlando:",
    "cs.insumos.del.trackedB": "o saldo se perde.",
    "cs.insumos.del.usedBy.one": "1 receita usa:",
    "cs.insumos.del.usedBy.other": "{n} receitas usam:",
    "cs.insumos.del.more": "e mais {n}",
    "cs.insumos.del.usedB": "Essas receitas ficam sem este ingrediente e o custo baixa.",
    "cs.insumos.del.unused": "Nenhum prato usa. Ele é apagado com o histórico de preços.",
    "cs.insumos.rename.title": "Mudar o nome",
    "cs.insumos.rename.label": "Nome",

    "cs.insumos.new.title": "Insumo novo",
    "cs.insumos.new.sub": "Algo que você compra para a cozinha.",
    "cs.insumos.new.name": "Nome",
    "cs.insumos.new.namePh": "Ex.: Farinha 0000",
    "cs.insumos.new.presets": "Sugestões",
    "cs.insumos.new.how": "Como você compra?",
    "cs.insumos.new.by.kg": "Por quilo",
    "cs.insumos.new.by.lt": "Por litro",
    "cs.insumos.new.by.u": "Por unidade",
    "cs.insumos.new.price": "Preço",
    "cs.insumos.new.noPrice": "Se não souber, deixe vazio: fica \"Falta preço\".",
    "cs.insumos.new.track": "Controlar o estoque",
    "cs.insumos.new.have": "Quanto você tem agora?",
    "cs.insumos.new.haveHint": "Se não souber, conte depois.",
    "cs.insumos.new.add": "Adicionar",
    "cs.insumos.new.retryHint": "Tente de novo.",
    "cs.insumos.new.done": "Você adicionou {name}",
    "cs.insumos.new.doneHave": "tem {qty}",
    "cs.insumos.new.doneNoPrice": "Quando souber o preço, coloque na ficha dele ou na próxima compra.",
    "cs.insumos.new.another": "Adicionar outro",
    "cs.insumos.new.open": "Ver a ficha",
    "cs.insumos.new.ok": "Pronto",
    "cs.insumos.new.openDup": "Abrir o que você tem",

    "cs.insumos.prep.sub": "O que você faz na cozinha e usa em vários pratos: molhos, massas, temperos.",
    "cs.insumos.prep.new": "Novo preparo",
    "cs.insumos.prep.empty.t": "Você ainda não tem preparos",
    "cs.insumos.prep.empty.b": "Monte um com os ingredientes e o rendimento: depois some aos pratos como mais um ingrediente.",
    "cs.insumos.prep.noName": "(sem nome)",
    "cs.insumos.prep.lines.one": "1 ingrediente",
    "cs.insumos.prep.lines.other": "{n} ingredientes",
    "cs.insumos.prep.yields": "rende {qty}",
    "cs.insumos.prep.eyebrow": "Preparo",
    "cs.insumos.prep.newTitle": "Preparo novo",
    "cs.insumos.prep.headSub": "Custeia uma vez e usa em vários pratos.",
    "cs.insumos.prep.costs": "Sai por",
    "cs.insumos.prep.total": "O preparo inteiro: {plata}",
    "cs.insumos.prep.yieldsShort": "rende {qty}",
    "cs.insumos.prep.name": "Nome",
    "cs.insumos.prep.namePh": "Ex.: Molho de tomate",
    "cs.insumos.prep.yield": "Quanto rende?",
    "cs.insumos.prep.yieldUnit": "Em que rende",
    "cs.insumos.prep.yieldHint": "O que sai da panela, já pronto.",
    "cs.insumos.prep.badYield": "Coloque quanto rende (um número maior que 0).",
    "cs.insumos.prep.unit.kg": "kg",
    "cs.insumos.prep.unit.lt": "litros",
    "cs.insumos.prep.unit.u": "porções",
    "cs.insumos.prep.per.kg": "o kg",
    "cs.insumos.prep.per.lt": "o litro",
    "cs.insumos.prep.per.u": "a porção",
    "cs.insumos.prep.portion.one": "{n} porção",
    "cs.insumos.prep.portion.other": "{n} porções",
    "cs.insumos.prep.lines": "O que leva?",
    "cs.insumos.prep.linesEmpty": "Ainda não tem ingredientes. Busque aqui embaixo.",
    "cs.insumos.prep.addPh": "Adicionar um ingrediente…",
    "cs.insumos.prep.already": "já está",
    "cs.insumos.prep.create": "Criar \"{name}\"",
    "cs.insumos.prep.createT": "Ingrediente novo",
    "cs.insumos.prep.createOk": "Adicionar ingrediente",
    "cs.insumos.prep.useDup": "Usar {name}",
    "cs.insumos.prep.amountAria": "Quantidade de {name} ({unit})",
    "cs.insumos.prep.remove": "Tirar {name}",
    "cs.insumos.prep.unused": "Nenhum prato usa ainda.",
    "cs.insumos.prep.needName": "Dê um nome",
    "cs.insumos.prep.saved": "Você salvou {name}",
    "cs.insumos.prep.deleted": "Você apagou {name}",
    "cs.insumos.prep.menuAria": "Mais ações do preparo",
    "cs.insumos.prep.del": "Apagar preparo",
    "cs.insumos.prep.delT": "Apagar {name}?",
    "cs.insumos.prep.delUsedB": "Esses pratos ficam sem este preparo e o custo baixa.",
    "cs.insumos.prep.delUnused": "Nenhum prato usa.",
    "cs.insumos.prep.draftBanner": "Você tem alterações não salvas neste preparo.",
    "cs.insumos.prep.draftKeep": "Continuar",
    "cs.insumos.prep.draftDiscard": "Descartar",
    "cs.insumos.prep.unitBlockedT.one": "É usado em 1 receita:",
    "cs.insumos.prep.unitBlockedT.other": "É usado em {n} receitas:",
    "cs.insumos.prep.unitBlockedB": "usam em {medida}. Com outro rendimento deixam de custar e de descontar. Faça um novo com este rendimento.",
    "cs.insumos.prep.copy": "Criar um novo assim",
    "cs.insumos.prep.copyName": "{name} (em {unidad})",
    "cs.insumos.prep.missingT": "Não encontramos este preparo",
    "cs.insumos.prep.toList": "Ver preparos",

    "cs.stock.title": "Estoque",
    "cs.stock.track.label": "Controlar",
    "cs.stock.track.done": "Agora você controla {name}. Falta contar.",
    "cs.stock.retrack.title": "Voltar a controlar {name}",
    "cs.stock.retrack.body": "Você já controlou antes. Desde então não foi descontado: conte agora para começar com o número de hoje.",
    "cs.stock.retrack.q": "Quanto você tem agora?",
    "cs.stock.retrack.ok": "Começar a controlar",
    "cs.stock.retrack.done": "Agora você controla {name}: começa com {qty}.",
    "cs.stock.off.body.one": "Não é controlado. Se ligar, baixa sozinho a cada venda de 1 prato e o garçom vê \"Esgotado\" quando acaba.",
    "cs.stock.off.body.other": "Não é controlado. Se ligar, baixa sozinho a cada venda de {n} pratos e o garçom vê \"Esgotado\" quando acaba.",
    "cs.stock.off.unused": "Não é controlado. Nenhum prato usa: só baixaria com o que você lançar à mão.",
    "cs.stock.neverCounted": "Você controla mas nunca contou: sem esse número não sabemos quanto tem.",
    "cs.stock.hay": "Tem agora",
    "cs.stock.worth": "Vale hoje",
    "cs.stock.oversold": "Vendeu a mais",
    "cs.stock.countAgain": "conte de novo",
    "cs.stock.oversoldHelp": "Vendeu mais do que você contou: conte de novo para o número servir.",
    "cs.stock.oversoldShort": "vendeu a mais",
    "cs.stock.stale": "Você contou há mais de 4 meses: conte de novo para o número servir.",
    "cs.stock.broken": "Uma receita pede numa unidade que não dá para converter: o salão não desconta. Veja \"Usado em\".",
    "cs.stock.noSales": "Não conseguimos ler as vendas: este número ainda não tira o que foi vendido.",
    "cs.stock.noSalesShort": "Sem vendas",
    "cs.stock.ledger.since": "Desde a contagem de {fecha} ({when}):",
    "cs.stock.ledger.sinceToday": "Desde a contagem de hoje:",
    "cs.stock.ledger.count": "Você contou",
    "cs.stock.ledger.bought": "+ Comprou",
    "cs.stock.ledger.sold": "− Vendeu",
    "cs.stock.ledger.waste": "− Perdeu",
    "cs.stock.ledger.adjusted": "± Corrigiu",
    "cs.stock.ledger.sum": "= Tem",
    "cs.stock.ledger.deletedDish": "(prato apagado)",
    "cs.stock.count.again": "Contou agora?",
    "cs.stock.count.first": "Quanto você tem agora?",
    "cs.stock.count.doneFirst": "Pronto: tem {qty}",
    "cs.stock.count.doneSame": "Pronto: {qty}, exatamente o que calculávamos.",
    "cs.stock.count.doneMissing": "Pronto: {qty}. Calculávamos {exp}: faltaram {diff} ({plata}).",
    "cs.stock.count.doneExtra": "Pronto: {qty}. Calculávamos {exp}: sobraram {diff} ({plata}).",
    "cs.stock.min.label": "Avise com menos de",
    "cs.stock.min.aria": "Avise com menos de ({unit}): {name}",
    "cs.stock.min.saved": "Salvo",
    "cs.stock.min.bad": "Coloque um número (com vírgula se tiver decimais).",
    "cs.stock.min.echo": "Com menos de {qty}, o garçom vai ver quantos restam (por exemplo, \"Restam 3\").",
    "cs.stock.min.help": "Com menos de {qty}, o garçom vê quantos restam (por exemplo, \"Restam 3\").",
    "cs.stock.min.none": "Sem aviso, o garçom só vê \"Esgotado\", nunca quantos restam.",
    "cs.stock.movs.title": "Movimentos (compras, contagens, perdas)",
    "cs.stock.movs.expected": "calculávamos {qty}",
    "cs.stock.movs.more": "Ver mais {n}",
    "cs.stock.movs.type.count": "Contagem",
    "cs.stock.movs.type.purchase": "Compra",
    "cs.stock.movs.type.waste": "Perda",
    "cs.stock.movs.type.adjust": "Correção",
    "cs.stock.movs.type.other": "Movimento",
    "cs.stock.dejar.title": "Deixar de controlar {name}?",
    "cs.stock.dejar.body": "Deixa de baixar com as vendas e o garçom não vê mais \"Esgotado\". O preço e as receitas ficam iguais.",
    "cs.stock.dejar.hay": "Hoje tem {qty}",
    "cs.stock.dejar.again": "Se depois voltar a controlar, conte de novo.",
    "cs.stock.dejar.ok": "Deixar de controlar",
    "cs.stock.dejar.done": "Você não controla mais {name}",
    "cs.stock.fix.title": "Corrigir à mão · {name}",
    "cs.stock.fix.help": "Para quando você sabe o número exato e não quer contar tudo. Se você contou, melhor usar \"Contou agora?\": mostra a diferença em dinheiro.",
    "cs.stock.fix.how": "Somar ou tirar",
    "cs.stock.fix.add": "Somar",
    "cs.stock.fix.sub": "Tirar",
    "cs.stock.fix.qty": "Quantidade",
    "cs.stock.fix.after": "Tem {from} → vai ficar {to}",
    "cs.stock.fix.afterOver": "Vai ficar {to}",
    "cs.stock.fix.note": "Por quê?",
    "cs.stock.fix.notePh": "Ex.: errei ao lançar a compra",
    "cs.stock.fix.ok": "Salvar correção",
    "cs.stock.fix.done": "Correção salva",
    "cs.stock.err.ordersT": "Não conseguimos ler as vendas:",
    "cs.stock.err.ordersB": "o estoque pode estar inflado.",
    "cs.stock.err.stale": "Mostramos o que lemos {when}.",
    "cs.stock.err.loadT": "Não conseguimos ler o estoque.",
    "cs.stock.err.loadB": "Confira a conexão e recarregue a página.",
    "cs.stock.err.reload": "Recarregar",
    "cs.stock.sales.read": "Vendas lidas {when}",
    "cs.stock.sales.reading": "Lendo as vendas…",
    "cs.stock.sales.refresh": "Atualizar",
    "cs.stock.pack": "Com a Gestão do local, o estoque baixa sozinho a cada venda e o garçom vê \"Esgotado\".",
  },
};

export default insumos;
